import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { AddCardOneClick as AddCardOneClickBase } from "@/components/AddCardOneClick";
import { useGetOneClickCards } from "@/hooks/useAuth";
import { motivoComercioNoResuelto } from "@/lib/oneclickCards";

export const AddCardOneClick = ({ onBackToWallet, triggerWalletRefresh }) => {
  const oneClickCards = useGetOneClickCards();
  const [maquinaId, setMaquinaId] = useState(null);
  const [codigoComercio, setCodigoComercio] = useState(null);
  const [apiKey, setApiKey] = useState(null);
  const [codigoTienda, setCodigoTienda] = useState(null);

  // Al montar, obtener la primera máquina disponible con OneClick para usarla
  // como contexto de la inscripción (equivalente a crearInscripction en WalletScreen.js mobile)
  useEffect(() => {
    // Sin máquina seleccionada (que es lo normal en la Billetera), esta llamada
    // es la ÚNICA fuente del comercio: si no resuelve, el componente base corta
    // con MSG_SIN_CREDENCIALES_INSCRIPCION y el usuario no puede agregar
    // tarjeta. Antes el fallo se tragaba en silencio (`.catch(() => {})`), así
    // que en Sentry quedaba el bloqueo (OPENMATIC-WEB-DB, 11 eventos en
    // producción) sin ningún rastro de su causa. Se reporta como `warning`
    // porque el error de cara al usuario lo emite el componente base.
    const reportar = (motivo, extra = {}) => {
      Sentry.captureMessage(
        "Billetera: no se pudo resolver el comercio OneClick para inscribir",
        {
          level: "warning",
          tags: { payment_flow: "oneclick" },
          extra: { motivo, ...extra },
        },
      );
    };

    oneClickCards
      .mutateAsync()
      .then((data) => {
        const motivo = motivoComercioNoResuelto(data);
        if (motivo) {
          reportar(motivo, {
            // Nunca el contenido: la respuesta trae credenciales de comercio.
            tipoRespuesta: Array.isArray(data) ? "array" : typeof data,
            largo: Array.isArray(data) ? data.length : null,
            mensajeBackend: data?.message ?? null,
          });
          return;
        }
        // NOTA (pendiente en Sima-apirest): este endpoint no devuelve
        // `maquina_id`, así que `setMaquinaId` siempre queda en
        // undefined/null. `oneclick_codigo_comercio` y
        // `oneclick_codigo_tienda` sí vienen y sí se usan.
        setMaquinaId(data[0].maquina_id);
        setCodigoComercio(data[0].oneclick_codigo_comercio);
        setApiKey(data[0].oneclick_apikey);
        setCodigoTienda(data[0].oneclick_codigo_tienda);
      })
      .catch((error) => {
        reportar("peticion_fallida", { mensajeError: error?.message ?? null });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSuccess = () => {
    triggerWalletRefresh?.();
    onBackToWallet?.();
  };

  return (
    <AddCardOneClickBase
      returnPath="/profile"
      onSuccess={handleSuccess}
      onBack={onBackToWallet}
      maquinaId={maquinaId}
      codigoComercio={codigoComercio}
      apiKey={apiKey}
      codigoTienda={codigoTienda}
    />
  );
};
